/* Sprint 7C: shared HMS sticky numbered stepper bar.
 *
 * Renders a horizontal pill of numbered step buttons, each scrolling
 * into the matching `Section` by anchorId on click. Visual port of
 * `FuelEnquiryStepper` (FuelEnquiryForm.js:1437) so the fuels recap
 * matches the enquiry/offer screen pattern.
 *
 * Props:
 *   - sections: [{ id, label, completed: bool }]
 *   - activeId: id of the currently visible section (drives `.active`)
 *   - onStepClick: (id) => void   ; consumer scrolls to anchor
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import './HMSStepper.css';

const HMSStepper = ({ sections, activeId, onStepClick }) => (
  <div className="hms-stepper" role="navigation" aria-label="Form sections">
    {sections.map((s, i) => {
      const cls = [
        'hms-step',
        activeId === s.id ? 'active' : '',
        s.completed ? 'completed' : '',
      ].filter(Boolean).join(' ');
      return (
        <React.Fragment key={s.id}>
          <button
            type="button"
            className={cls}
            onClick={() => onStepClick(s.id)}
            aria-current={activeId === s.id ? 'step' : undefined}
          >
            <span className="hms-step-number" aria-hidden="true">
              {s.completed ? <FontAwesomeIcon icon={faCheck} /> : i + 1}
            </span>
            <span className="hms-step-label">{s.label}</span>
          </button>
          {i < sections.length - 1 && <div className="hms-step-line" aria-hidden="true" />}
        </React.Fragment>
      );
    })}
  </div>
);

export default HMSStepper;
